import React, { useEffect, useState } from 'react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CRow,
  CCol
} from '@coreui/react';
import AxiosInstance from 'src/components/Axios';
import 'react-toastify/dist/ReactToastify.css';
import GalleryList from 'src/components/gallery/GalleryList';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
// import CreatableSelect from 'react-select/creatable';
import { transliterate } from 'transliteration';
import CIcon from '@coreui/icons-react';
import { cilX } from '@coreui/icons';
import GalleryMediaForm from '../media/GalleryMediaForm';

const GalleryObjectForm = ({ user, data, setData, parentId, actionShowModal, popup, galleryObject, setGalleryObject, typeChain = 'objects' }) => {
  if (!Permissions(user, 'Gallery', 'EDIT_GALLERY')) {
    return <PermissionsNoPage />;
  }

  const [media, setMedia] = useState((data != undefined && data.media != undefined) ? data.media.id : false);
  const [type, setType] = useState((data !== null && data.type) ? data.type : 'Images');
  const [name, setName] = useState((data?.name != undefined) ? data.name : '');
  const [sort, setSort] = useState((data?.sort != undefined) ? data.sort : 0);
  const [year, setYear] = useState((data?.year != undefined) ? data.year : new Date().getFullYear());

  const [embedLink, setEmbedLink] = useState('');
  const [updateLists, setUpdateLists] = useState(true);

  useEffect(() => {
    if (media !== false) {
      const article = {
        gallery: `/api/galleries/${data.id}`,
        media: `/api/media_objects/${media}`
      };
      AxiosInstance.post('/gallery_items', article).then(() => {
        setUpdateLists(true);
        setMedia(false);
      });
    }
  }, [media]);

  useEffect(()=> {
    if((data === null || data === undefined || !data) && parentId) {
      const article = {
        name: `new_g${parentId}`,
        year: year === '' ? new Date().getFullYear() : year,
        sort: parseInt(sort),
        type: type,
        ...(typeChain === 'objects' && {object: `/api/${typeChain}/${parentId}`}),
        ...(typeChain === 'pages' && {pages: [`/api/${typeChain}/${parentId}`]}),
      };
      AxiosInstance.post('/galleries', article).then((response) => {
        // console.log(response);
        if (response.status == 201) {
          popup.toastifySuccess("Галерею створено")
          setData(response.data);
          updateGalleryObjects(response.data.id);
          setName(response.data.name);
        }
      });
    }
  },[])

  const handleSubmit = event => {
    event.preventDefault();
    const article = {
      name: name,
      year: year,
      sort: parseInt(sort),
      type: type,
    };

    if (data != undefined) {
      AxiosInstance.put('/galleries/' + data.id, article).then((response) => {
        if (response.status == 200) {
          popup.toastifySuccess('Галерею оновлено');
          setData(response.data);
          updateGalleryObjects(data.id);
          actionShowModal(false);
        }
      });
    }
  }

  const updateGalleryObjects = (gallery_id) => {
    AxiosInstance.get(`/galleries/${gallery_id}`).then((responce) => {
      if (responce.status == 200) {
          const filtred = galleryObject.filter(gallery => gallery.id !== gallery_id);
          setGalleryObject([...filtred,  responce.data]);
      }
    });
  }

  const addGalleryPathItem = () => {
    if (embedLink.length > 0) {
      const article = {
        gallery: `/api/galleries/${data.id}`,
        urlPhoto: embedLink,
      };
      AxiosInstance.post('/gallery_items', article).then(() => {
        popup.toastifySuccess("Елемент галереї додано");
        setUpdateLists(true);
        setEmbedLink('');
      });
    }
    else {
      popup.toastifyWarning("Додайте посилання на файл")
    } 
  }

  function handleFTP(){
    const formatType = transliterate(type).toLowerCase().replace(/ /g, '_');
    AxiosInstance.get(`/create-dir-ftp?gallery_id=${data.id}&type=${formatType}`).then(response => {
      const data = response.data;
      if (data?.url !== undefined) {
        const ftpIp = process.env.REACT_APP_FTP_IP  || false;
        const ftpUser = process.env.REACT_APP_FTP_USER || false;
        if (!ftpIp || !ftpUser) {
          toastifySuccess("FTP не вказані доступи в .env файлі");
          return;
        }
        const ftp = 'winscp-ftp://' + ftpUser + '@' + ftpIp + '/objects' + data.url + '/';
        window.open(ftp, '_blank', 'noopener,noreferrer');
      }
    }).catch(() => {
      toastifySuccess("Error create directory");
    })
  }

  const handleCancel = () => {
    actionShowModal(false);
  };

    // Функція для рендерингу прев'ю
  const renderGalleryList = () => {
      // відобразити перелік ітемів галереї
      return (
          <GalleryList 
              galleryObject = {galleryObject} 
              setGalleryObject={setGalleryObject}
              updateGalleryObjects = {updateGalleryObjects}
              gallery_id={data?.id}
              gallery={data}
              updateLists={updateLists} 
              setUpdateLists={setUpdateLists} 
          />
      );
  };  

  return (
        <div style={{ position: 'relative' }}>
        <CButton
          type="button"
          color="black"
          onClick={handleCancel}
          style={{
            position: 'absolute',
            top: '-50px',
            right: '24px',
            zIndex: 10,
            padding: '4px 8px',
            minWidth: 'auto'
          }}
          title="Закрити"
        >
          <CIcon icon={cilX} size="lg" />
        </CButton>
        <CForm onSubmit={handleSubmit} className="mt-3">
          <div className="models-edit-form">
          <CRow className="align-items-start">
          <CCol xs={12} md={6}>
            <div className="mb-3">
              <CFormLabel>Type</CFormLabel>
              <div className="mb-3 models-edit-form-buttons-type">
                <CButton
                  color="secondary"
                  onClick={() => setType('Images')}
                  style={{ 
                    flex: 1,
                    backgroundColor: type === 'Images' ? '#FFFFFF' : '#f7f7f8',
                    borderColor: type === 'Images' ? '#DADADD' : 'transparent',
                    color: type === 'Images' ? '#434349' : '#6c757d'
                  }}
                >
                  Images
                </CButton>
                <CButton
                  color="secondary"
                  onClick={() => setType('Historic Photos')}
                  style={{ 
                    flex: 1,
                    backgroundColor: type === 'Historic Photos' ? '#FFFFFF' : '#f7f7f8',
                    borderColor: type === 'Historic Photos' ? '#DADADD' : 'transparent',
                    color: type === 'Historic Photos' ? '#434349' : '#6c757d'
                  }}
                >
                  Historic Photos
                </CButton>
                <CButton
                  color="secondary"
                  onClick={() => setType('Panoramas')}
                  style={{ 
                    flex: 1,
                    flexGrow: 1.5,
                    backgroundColor: type === 'Panoramas' ? '#FFFFFF' : '#f7f7f8',
                    borderColor: type === 'Panoramas' ? '#DADADD' : 'transparent',
                    color: type === 'Panoramas' ? '#434349' : '#6c757d'
                  }}
                >
                  Panoramas
                </CButton>
              </div>
              <div className="mb-3">
                <CFormLabel htmlFor="exampleFormControlInput1">Сортування</CFormLabel>
                <CFormInput type="number" id="exampleFormControlInput1" value={sort} onChange={(e) => setSort(parseInt(e.target.value) || '')} />
              </div>
            </div>
            <div className="mb-3" style={{minHeight: '333px'}}>
              {(type === 'Historic Photos' || type === 'Panoramas') ? (
                <>
                  <CFormLabel>Upload</CFormLabel>
                  <div className="models-upload-banner">
                    <img src="/models-template.svg" alt="FTP upload" className="models-upload-img" />
                    <div className="models-upload-text">
                      <div className="models-upload-title" 
                        onClick={handleFTP}
                      >
                        Launch FTP client <br/> for Gaussian Splatting upload
                      </div>
                      <a className="models-upload-subtitle" href="/instructions" target="_blank">
                      <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#fff" d="M549.7 124.1C543.5 100.4 524.9 81.8 501.4 75.5 458.9 64 288.1 64 288.1 64S117.3 64 74.7 75.5C51.2 81.8 32.7 100.4 26.4 124.1 15 167 15 256.4 15 256.4s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8 42.6 11.5 213.4 11.5 213.4 11.5s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.2 337.6l0-162.4 142.7 81.2-142.7 81.2z"/></svg>
                        Video instruction: How to use FTP
                      </a>
                    </div>
                  </div>
                  <div className="mt-3">
                    <CFormLabel htmlFor="embedCodeFtp">And paste link from FTP server</CFormLabel>
                    <div className="d-flex gap-2">
                      <CFormInput
                        id="embedCodeFtp"
                        value={embedLink}
                        onChange={(e) => setEmbedLink(e.target.value)}
                        placeholder="ftp://server/path/to/model"
                      />
                      <button type="button" onClick={addGalleryPathItem} className="btn btn-secondary w-25"> Add +</button>
                    </div>
                  </div>
                </>
              ) : (
                <div className='cutom-media-form'>
                  <GalleryMediaForm setNewMediaId={setMedia} toastifySuccess={popup.toastifySuccess} />
                </div>
              )}
            </div>
          </CCol>
          <CCol xs={12} md={6}>
              <div className="mb-3">
                <CFormLabel htmlFor="exampleFormControlInput1">Назва галереї</CFormLabel>
                <CFormInput
                  type="text"
                  style={{ marginTop: "8px" }}
                  id="exampleFormControlInput1"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <CFormLabel htmlFor="modelYearInput">Рік</CFormLabel>
                <CFormInput type="number" id="modelYearInput" value={year} onChange={(e) => setYear(parseInt(e.target.value) || '')} />
              </div>
            <div className="mb-3">
              <CFormLabel>Preview</CFormLabel>
              {renderGalleryList()}
            </div>
          </CCol>
        </CRow>
        </div>
        <div className="models-edit-form-buttons">
          <CButton
            type="button"
            color="secondary"
            variant="outline"
            onClick={handleCancel}
          >
            Скасувати
          </CButton>
          <CButton type="submit" color="success" className='item_add_button'>
            Зберегти
          </CButton>
        </div>
      </CForm>
      </div>
  );
};

export default GalleryObjectForm;